import { render, staticRenderFns } from "./PostActionButton.vue?vue&type=template&id=69569150&"
import script from "./PostActionButton.vue?vue&type=script&lang=ts&"
export * from "./PostActionButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports